import React from 'react'

function Home() {
  return (
    <div>My Home page</div>
  )
}

export default Home